import HomeContent from "@/pages/home/components/HomeContent";
import { AdvisorProvider } from "@/components/feature/AdvisorProvider";
import { advisors } from "@/mocks/advisors";

export default function DavidRoldan() {
  return (
    <AdvisorProvider advisor={advisors["david-roldan"]}>
      <HomeContent />
    </AdvisorProvider>
  );
}